import {fetchDataPromises} from '../../scheduling_fetch';

export const fetchAutoSchedulingData = () => {
	let requestUrl = process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'scheduling/autoSchedulingData';
	return fetchDataPromises([{url: requestUrl, method: 'GET'}]);
};
